import { useState, useEffect } from "react";

const STORAGE_KEY = "player-labels-visible";

export function useLabelsVisibility() {
  const [labelsVisible, setLabelsVisible] = useState(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored !== null ? stored === "true" : true; // По умолчанию включены
  });

  const toggleLabelsVisibility = () => {
    const newValue = !labelsVisible;
    setLabelsVisible(newValue);
    localStorage.setItem(STORAGE_KEY, newValue.toString());

    // Диспатчим событие для других компонентов
    window.dispatchEvent(
      new CustomEvent("labelsVisibilityChanged", {
        detail: { visible: newValue },
      })
    );
  };

  useEffect(() => {
    const handleLabelsVisibilityChange = (event) => {
      setLabelsVisible(event.detail.visible);
    };

    window.addEventListener(
      "labelsVisibilityChanged",
      handleLabelsVisibilityChange
    );

    return () => {
      window.removeEventListener(
        "labelsVisibilityChanged",
        handleLabelsVisibilityChange
      );
    };
  }, []);

  return [labelsVisible, toggleLabelsVisibility];
}
